import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { PageHero, Section, Button } from "@/components/UI";

export default function News() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/news").then((r) => setItems(r.data)).finally(() => setLoading(false)); }, []);

  const [featured, ...rest] = items;

  return (
    <>
      <PageHero overline="News & Advocacy" testId="news-hero"
        title="Standards, advocacy, and the field in motion"
        subtitle="Updates from the Council — from the development of national standards to advocacy for equitable access to restorative care across Canada." />

      <Section className="py-16 lg:py-24">
        {loading ? (
          <div className="flex justify-center py-24 text-ccpm-olive"><Loader2 className="animate-spin" /></div>
        ) : items.length === 0 ? (
          <p className="text-ccpm-taupe text-center py-24">No articles published yet.</p>
        ) : (
          <>
            {featured && (
              <Link to={`/news/${featured.slug}`} data-testid="news-featured" className="group block mb-16">
                <div className="grid lg:grid-cols-2 gap-10 items-center">
                  <div className="overflow-hidden aspect-[4/3] bg-ccpm-stone">
                    {featured.cover_image && <img src={featured.cover_image} alt={featured.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />}
                  </div>
                  <div>
                    <span className="overline text-ccpm-olive">{featured.category}</span>
                    <h2 className="font-serif text-3xl lg:text-4xl text-ccpm-charcoal leading-tight mt-4 group-hover:text-ccpm-olive transition-colors">{featured.title}</h2>
                    <p className="mt-5 text-ccpm-taupe font-light leading-relaxed">{featured.excerpt}</p>
                    <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-ccpm-olive">Read article <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" /></span>
                  </div>
                </div>
              </Link>
            )}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 border-t border-ccpm-border pt-16" data-testid="news-grid">
              {rest.map((a, i) => (
                <motion.div key={a.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}>
                  <Link to={`/news/${a.slug}`} className="group block" data-testid={`news-card-${a.slug}`}>
                    <div className="overflow-hidden aspect-[3/2] bg-ccpm-stone mb-5">
                      {a.cover_image && <img src={a.cover_image} alt={a.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />}
                    </div>
                    <span className="overline text-ccpm-olive">{a.category}</span>
                    <h3 className="font-serif text-2xl text-ccpm-charcoal leading-snug mt-2 group-hover:text-ccpm-olive transition-colors">{a.title}</h3>
                    <p className="mt-3 text-sm text-ccpm-taupe font-light leading-relaxed line-clamp-3">{a.excerpt}</p>
                  </Link>
                </motion.div>
              ))}
            </div>
          </>
        )}
      </Section>
    </>
  );
}
